import styled from "@emotion/styled";

export const BigNews = styled.article`
  position: relative;
  overflow: hidden;
  .imageWrapper {
    position: relative;
    height: 440px;
    margin-bottom: 30px;
    border-radius: 15px;
    overflow: hidden;
  }
  .contentWrapper {
    > * {
      margin-bottom: 15px;
    }
    a {
      display: inline-block;
    }
    .title {
      font-weight: 700;
      font-size: 20px;
    }
    .text {
      line-height: 32px;
    }
    .date {
      span {
      }
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginBottom: "40px",
      ".imageWrapper": {
        borderRadius: 0,
      },
      ".contentWrapper": {
        paddingInline: "16px",
      },
    },
  })}
`;

export const ArticlesWrapper = styled.main`
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: 60,
    },
  })}
`;

export const ArticleItem = styled.article`
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-bottom: 20px;
  margin-bottom: 20px;
  :not(:last-of-type) {
    border-bottom: 1px solid #e6e6e7;
  }
  .imageWrapper {
    position: relative;
    flex: 0 0 180px;
    width: 180px;
    height: 150px;
    overflow: hidden;
    margin-right: 30px;
    border-radius: 8px;
    ${({ theme }) => ({
      [theme.breakpoints.down("md")]: {
        flex: "0 0  140px",
        width: "140px",
        height: "110px",
        marginRight: "20px",
      },
    })}

    // used in TenderItems
      .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;

      background: ${({ type }) =>
        type === "tender"
          ? `#002a77e0`
          : type === "auction"
          ? `#9f0000e0`
          : "transparent"};
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-weight: 500;
        font-size: clamp(16px, 1.7vw, 24px);
        line-height: 41px;
        color: #ffffff;
      }
    }
  }
  .contentWrapper {
    width: 100%;

    .title {
      font-size: clamp(16px, 1.1vw, 18px);
      margin-bottom: 15px;
      min-height: 54px;
    }

    .text {
      margin-bottom: 10px;
      font-weight: 400;
      font-size: 15px;
      line-height: 26px;
      color: #000000;
      ${({ theme }) => ({
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      })}
    }
  }
  /*used in TenderItems*/
  .articleItemFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ${({ theme, type }) => ({
    [theme.breakpoints.down("sm")]: {
      ...(type === "tender" || type === "auction"
        ? {
            flexDirection: "column",
            ".imageWrapper": {
              width: "100%",
              margin: "0 0 20px 0",
            },
          }
        : {}),
    },
  })}
`;

export const EndDateStampWrapper = styled.div`
  background: ${({ theme }) => theme.palette.primary.main};
  border-radius: 4px;
  padding: 3px 5px;
  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 21px;
    color: #ffffff;
  }
`;

export const Aside = styled.aside`
  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 180.5%;
    color: #000000;
    ${({ theme }) => ({
      [theme.breakpoints.down("md")]: {
        fontSize: "22px",
      },
    })}
  }

  .archive {
    background: #f9f9f9;
    border-radius: 15px;
    padding: 30px 25px;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      text-transform: capitalize;

      .title {
        font-weight: 500;
        line-height: 31px;
      }
    }

    .seeAll {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: #17479e;
      cursor: pointer;
    }

    .MuiAccordion-root {
      background-color: inherit;
      box-shadow: none;
      border: none;

      :before {
        display: none;
      }
    }

    .MuiAccordionSummary-root {
      font-weight: 400;
      font-size: 16px;
      color: #808285;
      cursor: pointer;

      .Mui-expanded {
        font-weight: 600;
        color: #484848;
      }
    }

    .MuiAccordionDetails-root {
      display: flex;
      flex-direction: column;
      padding-inline: 30px;
      font-weight: 400;
      font-size: 14px;
      color: #808285;
      cursor: pointer;
      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        cursor: pointer;
        :hover {
          color: #17479e;
          svg path {
            fill: #17479e;
          }
        }
      }
    }
  }
`;

export const NewsListItem = styled.div`
  margin-top: 20px;
  padding-bottom: 10px;
  :not(:last-child) {
    border-bottom: 1px solid #e6e6e7;
  }
  .content {
    margin-bottom: 10px;
    font-size: 15px;
    line-height: 26px;
  }
`;
